import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import PersonList from './PersonList';

//redux

const Persons = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Empresa', icon: 'icon-building-2' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Personas' links={breadcrumbLinks} icon={'icon-users'} />
					<PersonList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Persons;
